import { useIpRestrictionStore } from "@/stores/useIpRestrictionStore";
import { parsePendingAgreements } from "@/lib/agreements";
import { useAgreementAcceptanceStore } from "@/stores/useAgreementAcceptanceStore";

// 既定は空 (同一オリジン相対)。本番/kind は ingress が `/api` を backend へ振り分け、
// ホストの Vite dev サーバーは vite.config.ts のプロキシが同じく backend へ委譲する。
export const API_URL: string = import.meta.env.VITE_API_URL ?? "";

interface ApiFetchInit extends RequestInit {
	redirectOn401?: boolean;
}

export async function apiFetch(
	path: string,
	{ redirectOn401 = true, ...init }: ApiFetchInit = {},
): Promise<Response> {
	const headers = new Headers(init?.headers);
	if (!headers.has("Content-Type") && !(init?.body instanceof FormData)) {
		headers.set("Content-Type", "application/json");
	}
	const res = await fetch(`${API_URL}${path}`, { ...init, headers, credentials: "include" });
	if (res.status === 401 && redirectOn401) {
		window.location.replace("/login");
	}
	await handleDeniedResponse(res);
	return res;
}

/**
 * 組織の接続元 IP 制限、または利用規約などへの未同意による 403 なら記録して true を返す
 * (どちらも画面全体が差し替わる)。本文は呼び出し側でも読めるよう複製から読むため、本文を読む前に呼ぶ。
 */
export async function handleDeniedResponse(res: Response): Promise<boolean> {
	if (res.status !== 403) return false;
	const body: unknown = await res
		.clone()
		.json()
		.catch(() => null);
	if (typeof body !== "object" || body === null) return false;
	const { type, code, pendingAgreements } = body as {
		type?: unknown;
		code?: unknown;
		pendingAgreements?: unknown;
	};
	if (type === "ip_not_allowed") {
		useIpRestrictionStore.getState().markBlocked();
		return true;
	}
	const pending = parsePendingAgreements(pendingAgreements);
	if (code === "agreement_acceptance_required" && pending.length > 0) {
		useAgreementAcceptanceStore.getState().require(pending);
		return true;
	}
	return false;
}
